import { useMemo } from 'react'
import { z } from 'zod'

export function useValidationSchema() {
  const validationSchema = useMemo(() => {
    // These fields are populated from the team store's logo rather than by the shopper, and none of
    // them render an error, so they act purely as a guard against submitting an incomplete logo.
    return z.object({
      logoName: z.string().min(1),
      logoDesignFile: z.string().optional(),
      logoImageSource: z.string().min(1),
      logoPlacement: z.object({}).optional(),
    })
  }, [])

  return validationSchema
}
